import CSSPlugin from 'gsapAlias/CSSPlugin'
import { Power1 } from 'gsapAlias/EasePack'
import TimelineLite from 'gsapAlias/TimelineLite'
import TweenLite from 'gsapAlias/TweenLite'

// eslint-disable-next-line no-unused-vars
const plugins = [CSSPlugin]

export const timeline = ({ wgsBox, dnaBox }) => {
  const tl = new TimelineLite({ paused: true })

  tl.add([
    TweenLite.fromTo(
      wgsBox.current,
      2,
      { x: '60vw', scale: 1.7 },
      { x: '0%', scale: 1, ease: Power1.easeOut },
    ),
    TweenLite.fromTo(
      dnaBox.current,
      2,
      { x: '-60vw', scale: 1.7 },
      { x: '0%', scale: 1, ease: Power1.easeOut },
    ),
  ])

  return tl
}

export const fadeOutTl = ({ boxRef }) =>
  TweenLite.to(boxRef.current, 0.3, { alpha: 0 })
